import { LocationUtilities, SiteUtilities, GA4Utilities } from '../utils';
const { onLocationReady } = LocationUtilities;
// OR
// const onLocationReady = LocationUtilities.onLocationReady;

/*
 * This file has geoLocation and simpleGeoLocation as global variables
 * which is being set during the first execution of any of the function.
 * Please look at the common encapsulation at the end for more info.
 */

function sendLeadToSociable (args) {
  /* All the submit handler will be passed with three args
    1. classname of the form
    2. DOMElement of the form itself
    3. Event
  */
  let $form;
  let socFormId = '';
  let geoLocation = {};
  if (session && session.simpleGeoLocation) {
    geoLocation = session.simpleGeoLocation;
  }
  // checking if there was no args passed then this might be a function which is used as a helper
  if (args.length === 0) {
    return;
  }
  try {
    // args[0] store the class name of the form
    if (args[0] && typeof args[0] === 'string') {
      socFormId = args[0];
    }
    // args[1] store the form itself
    if (args[1] && args[1].nodeName === 'FORM') {
      $form = $(args[1]);
    }
    // Sociable Lead Data
    const sociableData = {
      SocFormId: socFormId
    };
    if ($form) {
      const email = $form.find('input[type="email"]').val() || $form.find('input[name*="email"]').val() || '';
      const company = $form.find('input[name*="company"]').val() || '';
      const firstName = $form.find('input[name*="first-name"]').val() || '';
      const lastName = $form.find('input[name*="last-name"]').val() || '';
      const phoneNumber = $form.find('input[name*="phone"]').val() || '';

      if (email) {
        sociableData['email'] = email;
      }
      if (company) {
        sociableData['Company'] = company;
      }
      if (geoLocation.country && geoLocation.country.names && geoLocation.country.names['en']) {
        sociableData['Country'] = geoLocation.country.names['en'];
      }
      window.socTrackSend(sociableData);

      // Pushing fwFormSubmit event in dataLayer to ga for all successfull form
      if (!(socFormId.includes('-signupform') || socFormId.includes('-signup-form'))) {
        GA4Utilities.fwFormSubmit(socFormId, { company, email, firstName, lastName, phone: phoneNumber });
      }
    } else {
      throw new Error('Form object is not found');
    }
  } catch (e) {
    SiteUtilities.log(
      'Data push to Sociable Fail',
      'Error',
      'Submit Helpers - sendLeadToSociable',
      0,
      e
    );
  }
}
/*
 * This function is used to save user details in local storage during every form submit,
 * So we can auto populate any other form in the website with the available user details to
 * improve the user experience.
 */
function saveDataToAutoPopulateForms (args) {
  let $form;

  if (args.length === 0) {
    return;
  }

  try {
    const userDetails = JSON.parse(localStorage.getItem('form_details')) || {};

    if (args[1] && args[1].nodeName === 'FORM') {
      $form = $(args[1]);
    }

    if ($form) {
      const $email = $form.find('input[type="email"]') || $form.find('input[name*="email"]');
      if ($email && $email.val()) {
        userDetails.email = $email.val();
      }
      const $company = $form.find('input[name*="company"]');
      if ($company && $company.val()) {
        userDetails.company = $company.val();
      }
      const $firstName = $form.find('input[name*="first-name"]');
      if ($firstName && $firstName.val()) {
        userDetails['first-name'] = $firstName.val();
      }
      const $lastName = $form.find('input[name*="last-name"]');
      if ($lastName && $lastName.val()) {
        userDetails['last-name'] = $lastName.val();
      }
      const $phone = $form.find('input[name*="phone"]');
      if ($phone && $phone.val()) {
        userDetails.phone = $phone.val();
      }
      const $jobTitle = $form.find('input[name*="job-tile"]');
      if ($jobTitle && $jobTitle.val()) {
        userDetails['job-title'] = $jobTitle.val();
      }
      const $department = $form.find('select[name*="query-department"]');
      if ($department && $department.val()) {
        userDetails['query-department'] = $department.val();
      }
      const $jobLevel = $form.find('select[name*="query-job-level"]');
      if ($jobLevel && $jobLevel.val()) {
        userDetails['query-job-level'] = $jobLevel.val();
      }
      const $companyIndustry = $form.find('select[name*="query-company-industry"]');
      if ($companyIndustry && $companyIndustry.val()) {
        userDetails['query-company-industry'] = $companyIndustry.val();
      }
      const $website = $form.find('input[name*="url"]');
      if ($website && $website.val()) {
        userDetails['url'] = $website.val();
      }

      localStorage.setItem('form_details', JSON.stringify(userDetails));
    } else {
      throw new Error('Form object is not found');
    }
  } catch (e) {
    SiteUtilities.log(
      'Save Data to Local Storage Fail',
      'Error',
      'Submit Helpers - saveDataToAutoPopulateForms',
      1,
      e
    );
  }
}

function bindLocation (fn) {
  return function (...args) {
    function executeHandlers () {
      try {
        fn(...args);
      } catch (e) {
        // Do nothing
      } finally {
        /* As the sendLeadToSociable function also needs the geoLocation data
        and also this function needs to execute after the submit handler is executed.
        */
        sendLeadToSociable(args);
        saveDataToAutoPopulateForms(args);
      }
    }
    if (session.geoLocation && session.simpleGeoLocation) {
      executeHandlers();
    } else {
      onLocationReady((loc, simpleLoc) => {
        session.geoLocation = loc;
        session.simpleGeoLocation = simpleLoc;
        executeHandlers();
      });
    }
  };
}

var encapsulateLocation = function (submit) {
  const submitClone = Object.assign({}, submit);
  Object.keys(submitClone).map(k => {
    submitClone[k] = bindLocation(submitClone[k]);
  });
  return submitClone;
};

export default {
  encapsulateLocation
};
